exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: block;\n  padding: 8px;\n  background: #263238;\n  cursor: text; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Marion Surgical/Desktop/Sean/marion-surgical-master/src/app/core/components/highlight/highlight.component.scss
// module id = ../../../../../src/app/core/components/highlight/highlight.component.scss
// module chunks = main